import type { AxiosResponse } from "axios";

import api from "../utils/AxiosInterceptor";

export async function getOrganizations(): Promise<
  AxiosResponse<Organization[]>
> {
  const response = await api.get<Organization[]>("/api/v1/organizations");
  return response;
}
